import _ from 'lodash';

export const getScreenNameMapping = (state: {}): any => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.google-analytics.screenNameMapping`,
    {},
  );
};
